// extracted by mini-css-extract-plugin
export default {"membership":"AddTeamMember_membership__LQVQd","saveBtn":"AddTeamMember_saveBtn__EmrZr","hideParentModal":"AddTeamMember_hideParentModal__hNvxX"};